import { StyleSheet } from 'react-native';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

/** Micro-label «Vistas» en mobile. */
export const posRailSectionLabelStyle = {
  fontSize: 10,
  fontWeight: '700' as const,
  letterSpacing: 0.08,
  textTransform: 'uppercase' as const,
  color: ticketColors.ink3,
  fontFamily: ticketFonts.sans,
  paddingHorizontal: 2,
};

export const posRailSectionStyles = StyleSheet.create({
  sectionLabel: posRailSectionLabelStyle,
  chipRowBlock: {
    gap: 6,
  },
});
